import { WorkSheet } from '@sheet/edit';

const ALPHABET_CODE_A = 65;

/**
 * 컬럼 정보에 대한 index를 알파벳 컬럼 이름으로 변경하는 함숭비니다.
 * A-Z, AA-AZ .... ZZ 까지 변환합니다.
 */
export function numberToColumnName(index: number) {
  if (index < 26) {
    return String.fromCharCode(ALPHABET_CODE_A + index);
  }

  const prefix = String.fromCharCode(ALPHABET_CODE_A + index / 26 - 1);

  return prefix + String.fromCharCode(ALPHABET_CODE_A + (index % 26));
}

/**
 * 엑셀 컬럼 문자를 숫자로 변경합니다.
 * 예) A to 1, Z to 26, AA to 27
 */
export function lettersToNumber(letters: string) {
  let number = 0;
  for (let p = 0; p < letters.length; p += 1) {
    number = number * 26 + letters.charCodeAt(p) - (ALPHABET_CODE_A - 1);
  }
  return number;
}

/**
 * 엑셀 컬럼 이름에서 문자와 숫자를 분리합니다.
 * A1 to { text: 'A', number: 1}
 * AA12 to { text: 'AA', number: 12 }
 * 엑셀컬럼 이름형식이 아닌 경우 null 반환합니다.
 */
export function separateCharactersAndNumbers(str: string) {
  const regex = new RegExp('([0-9]+)|([a-zA-Z]+)', 'g');
  const splittedArray = str.match(regex);

  if (splittedArray && splittedArray.length === 2) {
    const parsedNumber = parseInt(splittedArray[1], 10);
    if (parsedNumber) {
      return { text: splittedArray[0], number: parsedNumber };
    }
  }
  return null;
}

/**
 * 엑셀 시트의 row, column 수를 반환합니다.
 */
export function getSheetSize(ref: string) {
  const lastCell = ref.split(':').pop() || '';
  const separated = separateCharactersAndNumbers(lastCell);
  if (separated) {
    return {
      rows: separated.number,
      columns: lettersToNumber(separated.text),
    };
  }

  return {
    rows: 0,
    columns: 0,
  };
}

/**
 * 엑셀의 데이터가 있는 마지막 row를 반환합니다.
 * @param dataStartRow 데이터 시작 row
 * @param formColumnCount
 * @param sheet
 */
export function findLatestExcelDataRowNumber({
  dataStartRow = 0,
  formColumnCount,
  sheet,
}: {
  dataStartRow?: number;
  formColumnCount: number;
  sheet: WorkSheet;
}): number {
  const ref = sheet['!ref'];
  let latestHasValueRow = 0;
  if (ref) {
    const { rows, columns } = getSheetSize(ref);

    for (let row = dataStartRow; row <= rows; row += 1) {
      let hasValues = false;

      // 빈 줄 확인
      for (let column = 0; column < columns && column < formColumnCount; column += 1) {
        const cell = sheet[`${numberToColumnName(column)}${row}`];
        const value = cell ? String(cell.w).trim() : '';
        if (value.length) {
          hasValues = true;
        }
      }

      if (hasValues) {
        latestHasValueRow = row;
      }
    }
  }

  return latestHasValueRow;
}
